module.exports = __webpack_public_path__ + "img/bg.cf95eb8f.jpg";